export const callSettingsEn = {
  title: "Calls",
  weekday: "Allowed hours on weekdays",
  weekend: "Allowed hours on weekends",
  start: "Start",
  end: "End",
  business_days: "Business days",
  days: {
    "1": "Mon",
    "2": "Tue",
    "3": "Wed",
    "4": "Thu",
    "5": "Fri",
    "6": "Sat",
    "7": "Sun",
  },
  max_attempts: "Maximum attempts",
  lease_minutes: "Lock duration (minutes)",
  predial_seconds: "Delay before dialing (seconds)",
  sip_server: "SIP server",
  holidays: "Holidays (one per line, YYYY-MM-DD)",
  script_fr: "Script (French)",
  script_en: "Script (English)",
  save: "Save",
  saved: "Call settings saved.",
  errors: {
    invalid_time: "Expected HH:MM.",
    end_before_start: "End must be after start.",
    out_of_range: "Value out of range.",
    invalid_date: "Invalid date (YYYY-MM-DD).",
    outside_crtc:
      "Outside CRTC allowed hours (weekdays 9:00–21:30, weekends 10:00–18:00).",
    no_business_day: "Pick at least one business day.",
    invalid_sip_server: "Invalid SIP server.",
  },
};
